/* GSJ speed: same-origin hover/touch prefetch (replaces the foreign-shop
   "booster-page-speed-optimizer.js" previously loaded from another store's
   CDN files). Warms the HTML of a link the shopper is about to click so the
   next navigation starts from cache. Skips carts/checkout/account, respects
   Save-Data, and prefetches each URL at most once per page. */
(function () {
  'use strict';
  if (!('querySelector' in document)) return;
  var conn = navigator.connection || {};
  if (conn.saveData) return;
  if (/(^|-)2g/.test(conn.effectiveType || '')) return;

  var seen = {};
  var SKIP = /\/(cart|checkout|account|admin|challenge|password)(\/|$|\?)/;

  function prefetch(url) {
    if (seen[url]) return;
    seen[url] = 1;
    var l = document.createElement('link');
    l.rel = 'prefetch';
    l.href = url;
    l.as = 'document';
    document.head.appendChild(l);
  }

  function candidate(e) {
    var a = e.target && e.target.closest ? e.target.closest('a[href]') : null;
    if (!a) return null;
    if (a.hasAttribute('download') || a.getAttribute('target') === '_blank') return null;
    var url;
    try { url = new URL(a.href, location.href); } catch (err) { return null; }
    if (url.origin !== location.origin) return null;
    if (SKIP.test(url.pathname)) return null;
    if (url.pathname === location.pathname && url.search === location.search) return null;
    return url.pathname + url.search;
  }

  var hoverTimer = null;
  document.addEventListener('mouseover', function (e) {
    var u = candidate(e);
    if (!u) return;
    clearTimeout(hoverTimer);
    hoverTimer = setTimeout(function () { prefetch(u); }, 65);
  }, { passive: true });
  document.addEventListener('mouseout', function () { clearTimeout(hoverTimer); }, { passive: true });
  document.addEventListener('touchstart', function (e) {
    var u = candidate(e);
    if (u) prefetch(u);
  }, { passive: true });
})();
